import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBold: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bold"><path d="M17.252 8V7.75C17.252 5.54086 15.4611 3.75 13.252 3.75H5.74219V12H13.252C15.4611 12 17.252 10.2091 17.252 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.74219 12V20.25H12.502" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13 20.25H14.25C16.4591 20.25 18.25 18.4591 18.25 16.25V16C18.25 13.7909 16.4591 12 14.25 12H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBold;
